import { render, staticRenderFns } from "./MessageCenterModule.vue?vue&type=template&id=6373cdd9"
import script from "./MessageCenterModule.vue?vue&type=script&lang=js"
export * from "./MessageCenterModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports